import { render, staticRenderFns } from "./TextCarousel.vue?vue&type=template&id=0614cf2f&scoped=true&"
import script from "./TextCarousel.vue?vue&type=script&lang=ts&"
export * from "./TextCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./TextCarousel.vue?vue&type=style&index=0&id=0614cf2f&prod&lang=css&"
import style1 from "./TextCarousel.vue?vue&type=style&index=1&id=0614cf2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614cf2f",
  null
  
)

export default component.exports